export const UPDATE_ACCOUNT_INFORMATION = "/api/myself"

export const UPDATE_PERSONAL_INFORMATION = "/api/myself"
export const CHANGE_PASSWORD = "/api/myself/reset-password"

export const FETCH_PROFILE = "/api/myself"
export const CREATE_APPOINTMENT = "/api/appointments"
export const APPOINTMENTS_LIST = "/api/myself/appointments"
export const APPOINTMENT = "/api/myself/appointments/:param"

export const DOWNLOAD_SCHEDULE = "/api/my-self/schedules"
export const FOLDER = "/api/folders/:param"